var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 110,
    viewBox: "0 0 230 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 50C17.0137 50 11.25 71.7388 11.25 80C11.25 89.0525 17.7028 96.6256 26.25 98.3694V106.25C26.25 108.323 27.9272 110 30 110C32.0728 110 33.75 108.323 33.75 106.25V98.3694C42.2972 96.6256 48.75 89.0525 48.75 80C48.75 71.4603 43.1728 50 30 50Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M128.796 67.6037V100.787L73.7959 100.879V67.6037L73.75 60.7287V32.4035C73.75 29.3327 75.3084 26.4909 77.8292 24.7951L96.1625 12.5576C99.2334 10.4951 103.267 10.4951 106.337 12.5576L124.671 24.7951C127.237 26.4909 128.75 29.3327 128.75 32.4035V60.7287L128.796 67.6037Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.833 97.3963H155.012V83.6463C159.367 82.2255 162.529 78.1463 162.529 73.3338V64.1671C162.529 58.163 157.625 53.2588 151.621 53.2588C145.617 53.2588 140.712 58.163 140.712 64.1671V73.3338C140.712 78.1005 143.829 82.1338 148.092 83.6005V97.3963H69.1666C67.2875 97.3963 65.7291 98.9546 65.7291 100.834C65.7291 102.713 67.2875 104.271 69.1666 104.271H151.346C151.437 104.271 151.483 104.317 151.575 104.317C151.667 104.317 151.712 104.271 151.804 104.271H160.833C162.712 104.271 164.271 102.713 164.271 100.834C164.271 98.9546 162.712 97.3963 160.833 97.3963Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.796 67.604H73.7959L73.75 60.729H128.75L128.796 67.604Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 104.271C99.3708 104.271 97.8125 102.713 97.8125 100.833V83.646C97.8125 81.7668 99.3708 80.2085 101.25 80.2085C103.129 80.2085 104.688 81.7668 104.688 83.646V100.833C104.688 102.713 103.129 104.271 101.25 104.271Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.25 49.2707C105.68 49.2707 109.271 45.6796 109.271 41.2498C109.271 36.82 105.68 33.229 101.25 33.229C96.8202 33.229 93.2291 36.82 93.2291 41.2498C93.2291 45.6796 96.8202 49.2707 101.25 49.2707Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200 50C187.014 50 181.25 71.7388 181.25 80C181.25 89.0525 187.703 96.6256 196.25 98.3694V106.25C196.25 108.323 197.927 110 200 110C202.073 110 203.75 108.323 203.75 106.25V98.3694C212.297 96.6256 218.75 89.0525 218.75 80C218.75 71.4603 213.173 50 200 50Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.c5322003acba8dafe6efe23c3d62cd1c.svg";
export { ForwardRef as ReactComponent };